// CRITICAL: Register Syncfusion license BEFORE any other imports
// This must be the first thing that runs to prevent trial message
import { registerLicense } from '@syncfusion/ej2-base';

// Register license key for Syncfusion version 26.2.9
// IMPORTANT: License key must be valid for the exact version you're using
const syncfusionLicenseKey = 'ORg4AjUWIQA/Gnt2U1hhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH9SdERiUXtacnVRRGJaWkZw';

// Register synchronously - this must complete before any Syncfusion components load
const licenseResult = registerLicense(syncfusionLicenseKey);
if (process.env.NODE_ENV === 'development') {
  if (licenseResult === true) {
    console.log('✓ Syncfusion license registered successfully');
  } else {
    console.warn('⚠ Syncfusion license registration returned:', licenseResult);
    console.warn('⚠ This may indicate an invalid or expired license key');
  }
}

// Sentry next, so it is watching before App and its imports start running.
import './sentry';
import React from 'react';
import ReactDOM from 'react-dom';
import store from './store';
import {Provider} from 'react-redux';
import App from './App';
import {Toaster} from 'react-hot-toast';
import Utils from './utils/utils';

if (!Utils.isDevEnv() && !Utils.isStagingEnv()) {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

ReactDOM.render(
  <Provider store={store}>
    <Toaster toastOptions={{
      className: '',
      style: {
        border: '1px solid #713200',
        padding: '16px',
        color: '#713200',
      },
    }}/>
    <App />

  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
